import React from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Route from "./Routes";
import PublicRoutes from "./Routes/PublicRoutes";
import "./assets/scss/themes.scss";

import { checkTokenExpiration } from "./slices/thunks";
import AuthProtected from "./Routes/AuthProtected";
import { useAuth } from "./Provider/AuthProvider";


// Activating fake backend

function App() {
    const navigate = useNavigate();
    const { user } = useAuth();

    useEffect(() => {
        checkTokenExpiration(navigate);
        const interval = setInterval(() => {
            checkTokenExpiration(navigate);
        }, 5000); // 5 seconds for testing

        return () => {
            clearInterval(interval);
        };
    }, [user, navigate]);

    return (
        <React.Fragment>
            {user ? (
                <AuthProtected>
                    <Route />
                </AuthProtected>
            ) : (
                <PublicRoutes />
            )}
        </React.Fragment>
    );
}

export default App;
